import { BiAlignJustify } from "react-icons/bi";

export const styles = {

   container: {
     width: "100%",
     height: "100%",
     background: "#fff",
     display: "flex",
     flexDirection: "column",
     position: "relative"
  },

  header: {
     fontWeight: "bold",
     display: "flex",
     alignItems: 'center',
     flexDirection : "row-reverse",
     justifyContent :"flex-end",
     gap : "4%"
    },
  

  h2: {
    margin: 0,
    fontSize: "16px",
    fontWeight: "600",
    color: "#111827",
  },

  options: {
    flex: 1, 
    display: "flex", 
    flexDirection: "column",
    marginLeft : "5%",
    marginTop : "4%",
    gap : "2%"
  },

  items: {
    display: "flex", 
    alignItems: "center",
    gap : "10px"
  },

  searchContainer: {
    position: "relative",
    margin: "16px 0",
  },

  input: {
    width: "100%",
    height:  "40px",
    padding:  "10px 10px 10px 40px",
    borderRadius: "20px",
    outline: "none",
    boxSizing: "border-box",
    border: "none",
    fontSize: "16px",
    backgroundColor: "#f9fafb",
    transition: "all 0.2s ease"
  },

   

  svg: {
    position: "absolute",
    left: "12px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "16px",
    height: "16px",
    fill: "#9ca3af",
  },


    li: {
    display: "flex",
    alignItems: "center",
    padding:  "10px",
    cursor: "pointer",
    borderRadius: "12px",
    marginBottom: "6px",
    backgroundColor: "transparent",
    transition: "all 0.2s ease",
  },

  img: {
    width:  "40px",
    height: "40px",
    borderRadius: "50%",
    marginRight: "10px",
    objectFit: "cover",
    overflow: "hidden"
  },

  imgPhoto: (hasPhoto) => ({
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    objectFit: "cover",
    backgroundColor: hasPhoto ? "transparent" : "#e5e7eb",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }),

   ul: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    flex: 1,
  },

  optionsTitle: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#111827",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    marginTop: 2,
  },


   headerAdd: {
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 16,
    marginBottom: 16,
  },

  groupPlaceholder: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    backgroundColor: "#e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  groupTitle: {
    marginTop: 12,
    fontSize: 18,
    textAlign: "center",
  },
  closeButton: {
    position: "absolute",
    top: 8,
    right: 8,
    border: "none",
    background: "transparent",
    fontSize: 20,
    cursor: "pointer",
    color: "#999",
  },
  groupPlaceholder: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    backgroundColor: "#e0e0e0",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  participantsList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: 12,
    marginTop: 16,
    maxHeight : "150px",
    overflow : "auto"
  },

  participant: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "6px 8px",
    borderRadius: 6,
    cursor: "default",
    backgroundColor: "#f9f9f9",
    position: "relative",
  },
  participantIcon: {
    width: 32,
    height: 32,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#E5E7EB",
    borderRadius: "50%",
  },
  participantName: {
    fontSize: 14,
    color: "#333",
  },
  participantMenuButton: {
    marginLeft: "auto",
    background: "none",
    border: "none",
    cursor: "pointer",
    fontSize: 16,
    color: "#666",
  },
  participantDropdown: {
    position: "absolute",
    top: 32,
    right: 0,
    backgroundColor: "#fff",
    border: "1px solid #ddd",
    borderRadius: 6,
    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
    width: 120,
    zIndex: 100,
  },
  participantDropdownItem: {
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: 14,
    color: "#333",
    borderRadius: 4,
    transition: "background 0.2s",
    display: "flex",
    alignItems: "center"
  },

  participantDropdownItemHover: {
    backgroundColor: "#f5f5f5",
  },
  
  
  loadingOverlay: {
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(255,255,255,0.6)",
  zIndex: 9999,
},

spinner: {
  width: 45,
  height: 45,
  border: "4px solid #e5e7eb",
  borderTop: "4px solid rgb(31, 58, 112)",
  borderRadius: "50%",
  animation: "spin 1s linear infinite",
}
};